import { ICountriesDictionary } from '@/dictionaries/utils/countries/types';
import { COUNTRIES } from '@/lib/countries';
import { Country } from '@/services/countries';

export function getSelectDescription(
  lang: string,
  countriesDict: ICountriesDictionary,
) {
  let toBeSortedCountries: Country[] = [];

  COUNTRIES.map((country) => {
    if (countriesDict[country.name as keyof ICountriesDictionary]) {
      toBeSortedCountries.push({
        ...country,
        name: countriesDict[country.name as keyof ICountriesDictionary],
      });
    }
  });

  toBeSortedCountries = toBeSortedCountries.sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  const selectDescription = {
    name: 'United Kingdom',
    code: 'GB',
    phoneCode: 44,
    countries: toBeSortedCountries,
    id: 223,
  };

  if (lang.includes('it')) {
    Object.assign(selectDescription, {
      name: 'Italia',
      code: 'IT',
      phoneCode: 39,
      id: 1,
    });
  }

  if (lang.includes('de')) {
    Object.assign(selectDescription, {
      name: 'Deutschland',
      code: 'DE',
      phoneCode: 49,
      id: 82,
    });
  }

  if (lang.includes('fr')) {
    Object.assign(selectDescription, {
      name: 'France',
      code: 'FR',
      phoneCode: 33,
      id: 74,
    });
  }

  return selectDescription;
}
